<template>
  <div class="flex min-h-screen flex-col justify-between">
    <AppTopbar />
    <AppHeader :menu-top="menuTop" :menu-main="menuMain" :dark="!isHomepage" />
    <PagePreloader :value="pageIsLoading" />
    <slot />
    <AppFooter :menu-footer="menuFooter" :menu-bottom="menuBottom" />
    <client-only>
      <AppUpButton />
      <ChatBot />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useFavicon, useMenus } from '~/composables';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import AppTopbar from '@/components/AppTopbar.vue';
import AppUpButton from '@/components/AppUpButton.vue';
import ChatBot from '~/components/ChatBot.vue';

const route = useRoute();
const { isLoading: pageIsLoading } = useLoadingIndicator({
  hideDelay: 0,
  resetDelay: 0,
});

const isHomepage = computed(() => route.fullPath === '/');

const { menuTop, menuMain, menuFooter, menuBottom } = useMenus();
const { favicon } = useFavicon();
const { siteTitle, frontkit } = useRuntimeConfig().public;
const { joinuApp } = frontkit;

const i18nHead = useLocaleHead({ key: 'key' });

useHead(() => ({
  titleTemplate: (title?: string) => title || siteTitle,
  htmlAttrs: {
    ...i18nHead.value.htmlAttrs,
  },
  meta: [...(i18nHead.value.meta ?? [])],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: joinuApp ? '/joinu-favicon.ico' : (favicon.value ?? '/favicon.ico'),
    },
    ...(i18nHead.value.link ?? []).map((link) => ({
      ...link,
      href: link.href || '/',
    })),
  ],
}));
</script>
